// @brizina/mls-wasm — the browser binding of the one MLS core (chat-mls.md
// CH3). pkg/ holds COMMITTED wasm-pack artifacts (rust/bz-mls/build-web.sh
// regenerates them); this wrapper only adds one-time async init, so callers
// never touch the raw glue.
//
// The ~1.1MB wasm loads lazily on first use, not with the app bundle — chat
// costs nothing until somebody opens it.

import init, { LinkHandshake, MlsSession } from '../pkg/bz_mls.js';

let ready: Promise<unknown> | null = null;

/** Load and initialize the MLS module once; resolves to the session class. */
export async function loadMls(): Promise<typeof MlsSession> {
  ready ??= init();
  await ready;
  return MlsSession;
}

/** Load the device-linking handshake class (CH6b/CH6c). `derive` on the
 * returned handshake yields a LinkChannel; both are opaque — no key material
 * ever crosses into JS. */
export async function loadLinking(): Promise<typeof LinkHandshake> {
  ready ??= init();
  await ready;
  return LinkHandshake;
}

export type { AddResult, MlsSession, ProcessResult } from '../pkg/bz_mls.js';
export type { LinkChannel, LinkHandshake } from '../pkg/bz_mls.js';
